import { useEffect, useState } from 'react'
import { Applicant, MultisectorData } from 'store/dashboard/types'
import LockIcon from '@mui/icons-material/Lock'
import { Box, FormControl, MenuItem, Select, SelectChangeEvent, Stack } from '@mui/material'

type Props = {
  data: MultisectorData
  onFilterApplied: (applicants: Applicant[]) => void
}

export default function FiltersSection({ data, onFilterApplied }: Props) {
  const [sectionOpened, setSectionOpened] = useState(true)
  const [filterGroup, setFilterGroup] = useState<string>('default')
  const [appliedFilters, setAppliedFilters] = useState<{ label: string; value: boolean }[]>([])

  // TODO PERMANENT FILTERS - Should be this applied always?
  // Results refinement (filteredMultisectorList)
  // Remove result if “whales_patent_in_percent” is zero
  // Remove result if research = TRUE
  // Remove result if whales_patents_in_categories is <= 3
  const filteredMultisectorList = data.multisector.filter(
    app => app.whales_patent_in_percent > 0 && !app.research && app.whales_patents_in_categories > 3,
  )

  useEffect(() => {
    let filtered: Applicant[] = []
    let filters: { label: string; value: boolean }[] = []
    if (filterGroup === 'default') {
      filtered = data.multisector.filter(
        app => app.whales_patent_in_percent > 0 && !app.research && app.whales_patents_in_categories > 3,
      )

      filters = [
        { label: 'whales_patent_in_percent > 0', value: true },
        { label: 'research is false', value: true },
        { label: 'whales_patents_in_categories > 3', value: true },
      ]
    } else if (filterGroup === 'group1') {
      filtered = data.multisector.filter(app => Number(app.comparison_score) > 100 && app.intersection_score_sum >= 3)

      filters = [
        { label: 'ipFootprint (comparison_score) > 100', value: true },
        { label: 'ipSimilarity (intersection_score_sum) >= 3', value: true },
      ]
    } else if (filterGroup === 'group2') {
      filtered = data.multisector.filter(app => Number(app.comparison_score) < 5 && app.intersection_score_sum < 3)

      filters = [
        { label: 'ipFootprint (comparison_score) less than 5', value: true },
        { label: 'ipSimilarity (intersection_score_sum) less than 3', value: true },
      ]
    } else if (filterGroup === 'group3') {
      filtered = data.multisector.filter(app => Number(app.comparison_score) > 100 && app.intersection_score_sum >= 3)

      filters = [
        { label: 'ipFootprint (comparison_score) > 100', value: true },
        { label: 'ipSimilarity (intersection_score_sum) >= 3', value: true },
      ]
    } else if (filterGroup === 'group4') {
      filtered = data.multisector.filter(app => app.research)

      filters = [
        { label: 'whales_patent_in_percent > 0', value: true },
        { label: 'research is false', value: true },
        { label: 'whales_patents_in_categories > 3', value: true },
      ]
    } else if (filterGroup === 'group5') {
      filtered = data.multisector
      filters = []
    } else {
      filtered = data.multisector
      filters = []
    }

    onFilterApplied(filtered)
    setAppliedFilters(filters)
  }, [filterGroup, data])

  const handleFilterChange = (event: SelectChangeEvent) => {
    setFilterGroup(event.target.value)
  }

  return (
    <Box mb={4}>
      <Box mx={0} mt={'3'}>
        <Stack direction="row" alignItems="right">
          <FormControl size="small" sx={{ mr: 1 }}>
            <Select
              labelId="primary-filters"
              name="primary-filters"
              value={filterGroup}
              onChange={handleFilterChange}
              sx={{ color: 'primary.main' }}>
              <MenuItem value="default">Consistently Ranked</MenuItem>
              <MenuItem value="none">New / Unknown Entrants</MenuItem>
              <MenuItem value="group1">Adjacent Heavyweights</MenuItem>
              <MenuItem value="group2">Partner Candidates</MenuItem>
              <MenuItem value="group3">Investor Pipeline Regeneration</MenuItem>
              <MenuItem value="group4">Academic Spinout Targets</MenuItem>
              <MenuItem value="group5">Raw data</MenuItem>
            </Select>
          </FormControl>

          <FormControl size="small" sx={{ mr: 1 }}>
            <Select
              disabled
              labelId="primary-filters-2"
              name="primary-filters-2"
              value={'default'}
              onChange={() => {}}
              sx={{ color: 'primary.main' }}>
              {/* <MenuItem value="default">Research/Educational Establishment</MenuItem>
              <MenuItem value="none">Low IP Weighted</MenuItem>
              <MenuItem value="none">Moderate IP Weighted</MenuItem> */}
              <MenuItem value="default">
                Customise <LockIcon fontSize="inherit" />
              </MenuItem>
              {/* <MenuItem value="group1">Low IP Similarity</MenuItem>
              <MenuItem value="group1">High IP Similarity</MenuItem>
              <MenuItem value="group2">Partner Candidates</MenuItem>
              <MenuItem value="group2">Investor Pipeline Regeneration</MenuItem>
              <MenuItem value="group2">Academic Spinout Targets</MenuItem> */}
            </Select>
          </FormControl>

          <FormControl size="small" sx={{ mr: 1 }}>
            <Select labelId="filters-data" id="filters-data" value={1} sx={{ color: 'primary.main' }}>
              <MenuItem value={1}>Owler demo data</MenuItem>
              <MenuItem value={2}>Investor Master (locked)</MenuItem>
              <MenuItem value={2}>CSV 1 (locked)</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Box>{' '}
      {/* {appliedFilters.length > 0 && (
        <Box mx={2}>
          <Typography variant="subtitle2" gutterBottom>
            Applied Filters:
          </Typography>
          <Box px={2} pb={2}>
            <FormGroup>
              {appliedFilters.map((filter, index) => (
                <FormControlLabel
                  // sx={{ m: 0 }}
                  key={index}
                  control={<Checkbox sx={{ p: 0.5 }} checked={filter.value} disabled />}
                  label={filter.label}
                />
              ))}
            </FormGroup>
          </Box>
        </Box>
      )} */}
    </Box>
  )
}
